/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBoolean,
  ApiEnvelopeVektorAdminKickResultDto,
  ApiEnvelopeVektorAdminPossessionListDto,
  ApiEnvelopeVektorBroadcasterStatsListDto,
  ApiEnvelopeVektorDiagnosticsStartDto,
  ApiEnvelopeVektorDiagnosticsStatusDto,
  ApiEnvelopeVektorMonitorBotListDto,
  ApiEnvelopeVektorMonitorDto,
  ApiEnvelopeVektorMonitorListDto,
  VektorAdminStartMonitorParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type vektorAdminListPossessionsResponse200 = {
  data: ApiEnvelopeVektorAdminPossessionListDto
  status: 200
}

export type vektorAdminListPossessionsResponse401 = {
  data: ApiEnvelopeVektorAdminPossessionListDto
  status: 401
}

export type vektorAdminListPossessionsResponseSuccess = (vektorAdminListPossessionsResponse200) & {
  headers: Headers;
};
export type vektorAdminListPossessionsResponseError = (vektorAdminListPossessionsResponse401) & {
  headers: Headers;
};

export type vektorAdminListPossessionsResponse = (vektorAdminListPossessionsResponseSuccess | vektorAdminListPossessionsResponseError)

export const getVektorAdminListPossessionsUrl = () => {




  return `/api/vektor/admin/possessions`
}

export const useVektorAdminListPossessionsHook = (): ( options?: RequestInit) => Promise<vektorAdminListPossessionsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVektorAdminListPossessionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type vektorAdminPossessionStatsResponse200 = {
  data: ApiEnvelopeVektorBroadcasterStatsListDto
  status: 200
}

export type vektorAdminPossessionStatsResponse401 = {
  data: ApiEnvelopeVektorBroadcasterStatsListDto
  status: 401
}

export type vektorAdminPossessionStatsResponseSuccess = (vektorAdminPossessionStatsResponse200) & {
  headers: Headers;
};
export type vektorAdminPossessionStatsResponseError = (vektorAdminPossessionStatsResponse401) & {
  headers: Headers;
};

export type vektorAdminPossessionStatsResponse = (vektorAdminPossessionStatsResponseSuccess | vektorAdminPossessionStatsResponseError)

export const getVektorAdminPossessionStatsUrl = () => {




  return `/api/vektor/admin/possessions/stats`
}

export const useVektorAdminPossessionStatsHook = (): ( options?: RequestInit) => Promise<vektorAdminPossessionStatsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVektorAdminPossessionStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type vektorAdminKickResponse200 = {
  data: ApiEnvelopeVektorAdminKickResultDto
  status: 200
}

export type vektorAdminKickResponse401 = {
  data: ApiEnvelopeVektorAdminKickResultDto
  status: 401
}

export type vektorAdminKickResponse403 = {
  data: ApiEnvelopeVektorAdminKickResultDto
  status: 403
}

export type vektorAdminKickResponse404 = {
  data: ApiEnvelopeVektorAdminKickResultDto
  status: 404
}

export type vektorAdminKickResponseSuccess = (vektorAdminKickResponse200) & {
  headers: Headers;
};
export type vektorAdminKickResponseError = (vektorAdminKickResponse401 | vektorAdminKickResponse403 | vektorAdminKickResponse404) & {
  headers: Headers;
};

export type vektorAdminKickResponse = (vektorAdminKickResponseSuccess | vektorAdminKickResponseError)

export const getVektorAdminKickUrl = (botId: string,) => {




  return `/api/vektor/admin/possessions/${botId}/kick`
}

export const useVektorAdminKickHook = (): (botId: string, options?: RequestInit) => Promise<vektorAdminKickResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getVektorAdminKickUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type vektorAdminStartDiagnosticsResponse200 = {
  data: ApiEnvelopeVektorDiagnosticsStartDto
  status: 200
}

export type vektorAdminStartDiagnosticsResponseSuccess = (vektorAdminStartDiagnosticsResponse200) & {
  headers: Headers;
};
;

export type vektorAdminStartDiagnosticsResponse = (vektorAdminStartDiagnosticsResponseSuccess)

export const getVektorAdminStartDiagnosticsUrl = (botId: string,) => {




  return `/api/vektor/admin/possessions/${botId}/diagnostics/start`
}

export const useVektorAdminStartDiagnosticsHook = (): (botId: string, options?: RequestInit) => Promise<vektorAdminStartDiagnosticsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getVektorAdminStartDiagnosticsUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type vektorAdminStopDiagnosticsResponse200 = {
  data: ApiEnvelopeVektorDiagnosticsStatusDto
  status: 200
}

export type vektorAdminStopDiagnosticsResponseSuccess = (vektorAdminStopDiagnosticsResponse200) & {
  headers: Headers;
};
;

export type vektorAdminStopDiagnosticsResponse = (vektorAdminStopDiagnosticsResponseSuccess)

export const getVektorAdminStopDiagnosticsUrl = (botId: string,) => {




  return `/api/vektor/admin/possessions/${botId}/diagnostics/stop`
}

export const useVektorAdminStopDiagnosticsHook = (): (botId: string, options?: RequestInit) => Promise<vektorAdminStopDiagnosticsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getVektorAdminStopDiagnosticsUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type vektorAdminDiagnosticsStatusResponse200 = {
  data: ApiEnvelopeVektorDiagnosticsStatusDto
  status: 200
}

export type vektorAdminDiagnosticsStatusResponseSuccess = (vektorAdminDiagnosticsStatusResponse200) & {
  headers: Headers;
};
;

export type vektorAdminDiagnosticsStatusResponse = (vektorAdminDiagnosticsStatusResponseSuccess)

export const getVektorAdminDiagnosticsStatusUrl = (botId: string,) => {




  return `/api/vektor/admin/possessions/${botId}/diagnostics/status`
}

export const useVektorAdminDiagnosticsStatusHook = (): (botId: string, options?: RequestInit) => Promise<vektorAdminDiagnosticsStatusResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getVektorAdminDiagnosticsStatusUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type vektorAdminExportDiagnosticsResponse200 = {
  data: void
  status: 200
}

export type vektorAdminExportDiagnosticsResponseSuccess = (vektorAdminExportDiagnosticsResponse200) & {
  headers: Headers;
};
;

export type vektorAdminExportDiagnosticsResponse = (vektorAdminExportDiagnosticsResponseSuccess)

export const getVektorAdminExportDiagnosticsUrl = (botId: string,) => {




  return `/api/vektor/admin/possessions/${botId}/diagnostics/export`
}

export const useVektorAdminExportDiagnosticsHook = (): (botId: string, options?: RequestInit) => Promise<vektorAdminExportDiagnosticsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getVektorAdminExportDiagnosticsUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type vektorAdminStartMonitorResponse200 = {
  data: ApiEnvelopeVektorMonitorDto
  status: 200
}

export type vektorAdminStartMonitorResponseSuccess = (vektorAdminStartMonitorResponse200) & {
  headers: Headers;
};
;

export type vektorAdminStartMonitorResponse = (vektorAdminStartMonitorResponseSuccess)

export const getVektorAdminStartMonitorUrl = (botId: string,
    params?: VektorAdminStartMonitorParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vektor/admin/monitor/${botId}/start?${stringifiedParams}` : `/api/vektor/admin/monitor/${botId}/start`
}

export const useVektorAdminStartMonitorHook = (): (botId: string,
    params?: VektorAdminStartMonitorParams, options?: RequestInit) => Promise<vektorAdminStartMonitorResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: VektorAdminStartMonitorParams, options?: RequestInit) => {

        return customFetcher(getVektorAdminStartMonitorUrl(botId,params),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type vektorAdminStopMonitorResponse200 = {
  data: ApiEnvelopeBoolean
  status: 200
}

export type vektorAdminStopMonitorResponseSuccess = (vektorAdminStopMonitorResponse200) & {
  headers: Headers;
};
;

export type vektorAdminStopMonitorResponse = (vektorAdminStopMonitorResponseSuccess)

export const getVektorAdminStopMonitorUrl = (botId: string,) => {




  return `/api/vektor/admin/monitor/${botId}/stop`
}

export const useVektorAdminStopMonitorHook = (): (botId: string, options?: RequestInit) => Promise<vektorAdminStopMonitorResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getVektorAdminStopMonitorUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type vektorAdminListMonitorsResponse200 = {
  data: ApiEnvelopeVektorMonitorListDto
  status: 200
}

export type vektorAdminListMonitorsResponseSuccess = (vektorAdminListMonitorsResponse200) & {
  headers: Headers;
};
;

export type vektorAdminListMonitorsResponse = (vektorAdminListMonitorsResponseSuccess)

export const getVektorAdminListMonitorsUrl = () => {




  return `/api/vektor/admin/monitor`
}

export const useVektorAdminListMonitorsHook = (): ( options?: RequestInit) => Promise<vektorAdminListMonitorsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVektorAdminListMonitorsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type vektorAdminListMonitorableBotsResponse200 = {
  data: ApiEnvelopeVektorMonitorBotListDto
  status: 200
}

export type vektorAdminListMonitorableBotsResponseSuccess = (vektorAdminListMonitorableBotsResponse200) & {
  headers: Headers;
};
;

export type vektorAdminListMonitorableBotsResponse = (vektorAdminListMonitorableBotsResponseSuccess)

export const getVektorAdminListMonitorableBotsUrl = () => {




  return `/api/vektor/admin/monitor/bots`
}

export const useVektorAdminListMonitorableBotsHook = (): ( options?: RequestInit) => Promise<vektorAdminListMonitorableBotsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVektorAdminListMonitorableBotsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type vektorAdminExportMonitorResponse200 = {
  data: void
  status: 200
}

export type vektorAdminExportMonitorResponseSuccess = (vektorAdminExportMonitorResponse200) & {
  headers: Headers;
};
;

export type vektorAdminExportMonitorResponse = (vektorAdminExportMonitorResponseSuccess)

export const getVektorAdminExportMonitorUrl = (botId: string,) => {




  return `/api/vektor/admin/monitor/${botId}/export`
}

export const useVektorAdminExportMonitorHook = (): (botId: string, options?: RequestInit) => Promise<vektorAdminExportMonitorResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getVektorAdminExportMonitorUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


